import React, { useState, useCallback } from 'react';
import {Form} from "@heroui/form";
import {Button} from "@heroui/button";
import {Input} from "@heroui/input";
import {Spinner} from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
} from "@heroui/modal";

const PasswordResetForm = ({cancelReset, loginEmail}) => {
  const [email, setEmail] = useState();
  const [error, setError] = useState();
  const [info, setInfo] = useState();
  const [fetching, setFetching] = useState(false);

  const submitReset = useCallback(async (e) => {
    e.preventDefault();
    if (!fetching) {
      setFetching(true);
      let fd = new FormData();
      fd.append('email', email);
      const d = await fetch('/api/v1/users/password_reset', {method: 'POST', body: fd});
      setFetching(false);
      if (d?.status !== 200) {
        // Failure. You. Failure.
        setError('Somethign went wrong.');
        return false;
      } else {
        // Reset submit success... 
        // const data = await d.json();
        setInfo('Reset submitted. Please check your email for a password reset link.');
        return true;
      }
    }
  }, [email, fetching]);

  return (
    <div style={{position: 'absolute', zIndex: 999999999, top: '20px', left: '20px'}}>
        <Modal placement='top' isOpen={true} isDismissable={true} isKeyboardDismissDisabled={true} onClose={cancelReset}>
          <ModalContent>
            <ModalHeader className='flex flex-col gap-1'>
              Reset Password
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={submitReset} style={{zIndex: 999999999}}
                    className="w-full max-w-xs flex flex-col gap-4">
                { error && <div className='error-header'> {error} </div> }
                { info && <div className='info-header'> {info} </div> }
                <Input isRequired label='Your email address'
                       type='email'
                       variant='bordered'
                       validationBehavior='native'
                       placeholder='mylogin@example.com'
                       onChange={(d) => setEmail(d.target.value)}
                />
                <div>
                  <Button type='submit' onPress={cancelReset}>{fetching ? <Spinner /> : 'Cancel'}</Button>
                  <Button style={{marginLeft: '12px', marginRight: '12px'}} color='success' type='submit'>Submit</Button>
                  <a style={{fontSize: '14px', color: '#1888f0'}} href='https://activistmailer.com/support-page/'>Support</a>
                </div>
              </Form>
            </ModalBody>
          </ModalContent>
        </Modal>
    </div>
  );
}

export default PasswordResetForm;
